import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { useCurrentWorkspace } from '@gripp/shared-logic';
import { Colors } from '@gripp/shared-ui';
import { StyleSheet, Text, View } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';
import { EditAlertForm } from './editAlertForm';

type EditAlertMenuProps = {
  label: any;
  alertId: string;
};

export const EditAlertMenu = (props: EditAlertMenuProps) => {
  const currentWorkspace = useCurrentWorkspace();

  return (
    currentWorkspace && (
      <View style={styles.alertEditContainer}>
        <ModalButton
          label=""
          customButton={
            <View style={{ flexDirection: 'row' }}>
              <MaterialCommunityIcons
                name="pencil-outline"
                color={Colors.blackText}
                size={16}
                style={styles.icon}
              />
              <Text style={styles.label}>{props.label}</Text>
            </View>
          }
          buttonStyle={styles.editAlertButton}
          modalComponent={({ onComplete }) => {
            return (
              <EditAlertForm
                onComplete={onComplete}
                workspaceId={currentWorkspace}
                alertId={props.alertId}
              />
            );
          }}
          containerStyle={styles.modalContainer}
        />
      </View>
    )
  );
};

const styles = StyleSheet.create({
  alertEditContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 20,
  },
  editAlertButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 117,
    height: 32,
    backgroundColor: Colors.white,
    borderRadius: 16,
  },
  icon: {
    marginRight: 4,
  },
  label: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: -0.25,
  },
  modalContainer: {
    alignSelf: 'center',
    backgroundColor: Colors.primaryGrayBackground,
    borderRadius: 10,
    width: 560,
    height: 218,
  },
});
